import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { i18nTranslate } from 'src/utils'
import { Row, Col } from 'react-bootstrap'
import { EditTeam } from './EditTeam'
import { Link } from 'react-router-dom'
import { pageNames } from 'src/routes/pathParams'
import { AccordionBlock } from 'src/views/components'
import './styles.scss'

@observer
class TeamsListCard extends React.Component {
  @observable isActive = false
  @observable teamId = ''

  handleVisibility = props => {
    this.teamId = props?.index
    this.isActive = props?.isOpen
  }

  renderTeamList = team => {
    const { name, status, costCentreId, teamBuyer = [], id } = team
    const selectedCostCenter = this.props.costCenters.find(
      costCenter => costCenter.value == costCentreId
    )
    const statusText =
      status.toLowerCase() === 'active'
        ? i18nTranslate('status.active', 'Active')
        : i18nTranslate('status.inActive', 'Inactive')
    let selectedCostCenterName = ''
    if (selectedCostCenter) {
      selectedCostCenterName = selectedCostCenter.label
    }
    return (
      <Row noGutters className="text-capitalize font-weight-normal">
        <Col className="team-list-wrapper" data-testid="qa-team">
          <Row noGutters className="text-capitalize">
            <Col lg={6}>
              <div className="team-item mb-1" data-testid="qa-team-id">
                <span className="team-colon-align">
                  {i18nTranslate('team.id', 'Team ID')}
                </span>
                : <span data-testid={`qa-team-id-${id}`}>{id}</span>
              </div>
              <div className="mb-1" data-testid="qa-team-name">
                <span className="team-item team-colon-align">
                  {i18nTranslate('team.name', 'Team Name')}
                </span>
                : <span data-testid={`qa-team-name-${name}`}>{name}</span>
              </div>
              <div className="mb-1" data-testid="qa-team-size">
                <span className="team-item team-colon-align">
                  {i18nTranslate('team.size', 'Team Size')}
                </span>
                :
                <Link
                  className="text-primary mb-2"
                  to={pageNames.b2bUserManagement}
                  data-testid={`qa-team-size-${teamBuyer.length}`}>
                  {' ' + teamBuyer.length}
                </Link>
              </div>
            </Col>

            <Col
              lg={6}
              className="team-list-wrapper"
              data-testid="qa-costcenter">
              <div className="team-item mb-1" data-testid="qa-costcenter-name">
                <span className="team-colon-align">
                  {i18nTranslate('team.costCenter', 'Cost Center')}
                </span>
                :{' '}
                <span
                  data-testid={`qa-costcenter-name-${selectedCostCenterName}`}>
                  {selectedCostCenterName}
                </span>
              </div>
              <div
                className="team-item mb-1"
                data-testid="qa-costcenter-status">
                <span className="team-colon-align">
                  {i18nTranslate('team.status', 'Status')}
                </span>
                :
                <span
                  className={
                    status.toLowerCase() === 'active'
                      ? 'text-success'
                      : 'text-danger'
                  }
                  data-testid={`qa-costcenter-status-${statusText}`}>
                  {' '}
                  {statusText}
                </span>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }

  teamsList = (team, index) => {
    const isVisible = this.teamId === index ? this.isActive : false
    return (
      <div className="bg-white mb-2" key={index}>
        <AccordionBlock
          title={this.renderTeamList(team)}
          key={index}
          isActive={isVisible}
          onClick={this.handleVisibility}
          index={index}
          className={'team-list-accordian-wrapper'}>
          <EditTeam
            onToggle={this.handleVisibility}
            team={team}
            isActive={isVisible}
            {...this.props}
          />
        </AccordionBlock>
      </div>
    )
  }
  render() {
    const { teamsData } = this.props
    return (
      <div data-testid="qa-list-team-management">
        {teamsData && teamsData.map(this.teamsList)}
      </div>
    )
  }
}

export default TeamsListCard
export { TeamsListCard }
